// ConsultantProfile.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "./astrologerprofile.css";

const ConsultantProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [astro, setAstro] = useState(null);
  const [images, setImages] = useState([]);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [paymentType, setPaymentType] = useState("chat");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const [reviews, setReviews] = useState([]);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [reviewSubmitting, setReviewSubmitting] = useState(false);

  const [reviewForm, setReviewForm] = useState({
    rating: 0,
    review: "",
  });

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    birthTime: "",
    birthPlace: "",
  });

  const [errors, setErrors] = useState({});

  const getPaymentAmount = () => {
    if (paymentType === "consultation") return 111;
    return Number(astro?.talkprice || 0);
  };

  useEffect(() => {
    const fetchAstroDetails = async () => {
      try {
        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/astrologerdetails",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ astrologerid: id }),
          },
        );

        const result = await response.json();

        if (result.status && result.data) {
          const basePath =
            "https://dashboard.jyotirvani.com/uploads/astrologerImage/";

          const astroData = result.data;

          setAstro({
            id: astroData.id,
            name: astroData.name,
            profileImage: basePath + astroData.profileimage,
            experience: astroData.experience + " Years",
            languages: astroData.speak
              ? astroData.speak.split(",").map((l) => l.trim())
              : [],
            expertise: astroData.Expertise
              ? astroData.Expertise.split(",").map((e) => e.trim())
              : [],
            availableVia: astroData.Available
              ? astroData.Available.split(",").map((a) => a.trim())
              : [],
            startPrice: `₹${astroData.talkprice}`,
            talkprice: Number(astroData.talkprice),
            rating: 4.9,
            tag: "Top Astrologer",
            about: astroData.about || "",
          });

          const galleryImages = Array.isArray(astroData.astrologerdetails)
            ? astroData.astrologerdetails.map((img) => basePath + img.image)
            : [];

          setImages(galleryImages);
        }
      } catch (err) {
        console.error("Error fetching astrologer details:", err);
      }
    };

    fetchAstroDetails();
  }, [id]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setReviewLoading(true);

        const response = await fetch(
          "https://dashboard.jyotirvani.com/api/astrologerreviews",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ astrologerid: id }),
          },
        );

        const result = await response.json();

        if (result.status && Array.isArray(result.data)) {
          setReviews(result.data);
        } else {
          setReviews([]);
        }
      } catch (error) {
        console.error("Review fetch error:", error);
        setReviews([]);
      } finally {
        setReviewLoading(false);
      }
    };

    fetchReviews();
  }, [id]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);

    const paymentStatus =
      query.get("payment") ||
      query.get("status") ||
      query.get("payment_status");

    const orderId = query.get("order_id");

    if ((paymentStatus === "success" || paymentStatus === "paid") && orderId) {
      const storedMessage =
        localStorage.getItem("astro_whatsapp_message") ||
        `🔮 TEAM Jyotirvani

Payment received successfully.

Astrologer: ${astro?.name || "Our Astrologer"}
Order ID: ${orderId}

Please continue my astrology consultation process.

– Team Jyotirvani`;

      setWhatsappMessage(storedMessage);
      setSuccessMessage(`✅ Payment Successful! Order ID: ${orderId}`);
      setShowSuccessPopup(true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 1500);
    }
  }, [location.search, astro]);

  const handlePayClick = () => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      navigate("/login", { state: { from: location } });
      return;
    }

    setPaymentType("chat");
    setShowModal(true);
    setErrors({});
  };

  const handleBookConsultation = (e) => {
    e.preventDefault();

    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

    if (!isLoggedIn) {
      navigate("/login", { state: { from: location } });
      return;
    }

    setPaymentType("consultation");
    setShowModal(true);
    setErrors({});
  };

  const handleClose = () => {
    setShowModal(false);
    setErrors({});
    setIsPaying(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    let nextValue = value;

    if (name === "phone") {
      nextValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setForm((prev) => ({
      ...prev,
      [name]: nextValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name is required";

    if (!form.email.trim()) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      newErrors.email = "Enter a valid email";

    if (!form.phone.trim()) newErrors.phone = "Phone number is required";
    else if (!/^\d{10}$/.test(form.phone))
      newErrors.phone = "Enter a valid 10-digit phone number";

    if (!form.dob) newErrors.dob = "Date of Birth is required";
    if (!form.birthTime) newErrors.birthTime = "Birth Time is required";
    if (!form.birthPlace.trim())
      newErrors.birthPlace = "Birth Place is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handlePayment = async () => {
    if (!validateForm()) return;

    try {
      setIsPaying(true);

      const finalAmount = getPaymentAmount();
      const serviceName =
        paymentType === "consultation" ? "Book Consultation" : "Chat Now";

      const message = `🔮 TEAM Jyotirvani
Your Gateway to Cosmic Clarity

Payment received successfully.

Service: ${serviceName}
Astrologer: ${astro.name}
Amount: ₹${finalAmount}

Customer Birth Details:
Full Name: ${form.name}
Date of Birth: ${form.dob}
Time of Birth: ${form.birthTime}
Place of Birth: ${form.birthPlace}
Contact Number: ${form.phone}
Email: ${form.email}

Once we receive your details, our team will schedule your personalized session and reach out to you shortly.

Let the stars guide you…
– Team Jyotirvani`;

      localStorage.setItem("astro_whatsapp_message", message);

      const res = await fetch(
        "https://dashboard.jyotirvani.com/api/generate-token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            amount: finalAmount,
            name: form.name,
            email: form.email,
            phone: form.phone,
            type: paymentType,
            item_id: astro.id,
            item_name: astro.name,
          }),
        },
      );

      const text = await res.text();

      let data;

      try {
        data = JSON.parse(text);
      } catch (error) {
        toast.error("Laravel JSON return korche na");
        setIsPaying(false);
        return;
      }

      if (!res.ok || !data.status) {
        toast.error(data?.error || data?.message || "Payment request failed");
        setIsPaying(false);
        return;
      }

      if (!window.Razorpay) {
        toast.error(
          "Razorpay SDK load hoyni. public/index.html e script add koro.",
        );
        setIsPaying(false);
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: "JyotirVani",
        description: serviceName,
        order_id: data.order_id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              "https://dashboard.jyotirvani.com/api/verify-razorpay-payment",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  local_order_id: data.local_order_id,
                  return_type: paymentType,
                }),
              },
            );

            const verifyData = await verifyRes.json();

            if (verifyData.status) {
              const user = JSON.parse(localStorage.getItem("user") || "null");

              const historyKey = user?.email
                ? `payment_history_${user.email}`
                : "payment_history_guest";

              const oldHistory =
                JSON.parse(localStorage.getItem(historyKey)) || [];

              const newHistory = {
                order_id: data.local_order_id,

                type:
                  paymentType === "consultation"
                    ? "consultation"
                    : "astrologer",

                title:
                  paymentType === "consultation"
                    ? `Consultation - ${astro?.name}`
                    : `Chat - ${astro?.name}`,

                amount: finalAmount,

                payment_status: "success",

                payment_mode: "Razorpay",

                date: new Date().toISOString(),
              };

              localStorage.setItem(
                historyKey,
                JSON.stringify([newHistory, ...oldHistory]),
              );

              setShowModal(false);

              setWhatsappMessage(message);

              setSuccessMessage(
                `✅ Payment Successful! Order ID: ${data.local_order_id || ""}`,
              );

              setShowSuccessPopup(true);

              setIsPaying(false);
            } else {
              toast.error(verifyData.message || "Payment verification failed");
              setIsPaying(false);
            }
          } catch (err) {
            console.error("VERIFY ERROR:", err);
            toast.error("Payment verification failed");
            setIsPaying(false);
          }
        },

        prefill: {
          name: form.name,
          email: form.email,
          contact: form.phone,
        },

        notes: {
          local_order_id: data.local_order_id,
          astrologer_id: astro.id,
          astrologer_name: astro.name,
          service: serviceName,
        },

        theme: {
          color: "#7c3aed",
        },

        modal: {
          ondismiss: function () {
            setIsPaying(false);
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (error) {
      console.error("Payment Error:", error);
      toast.error(error?.message || "Payment failed");
      setIsPaying(false);
    }
  };

  const handleReviewSubmit = async (e) => {
    e.preventDefault();

    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    const user = JSON.parse(localStorage.getItem("user") || "null");

    if (!isLoggedIn || !user) {
      toast.error("Please login to add review");
      navigate("/login", { state: { from: location } });
      return;
    }

    if (!reviewForm.rating) {
      toast.error("Please select rating");
      return;
    }

    if (!reviewForm.review.trim()) {
      toast.error("Please write your review");
      return;
    }

    try {
      setReviewSubmitting(true);

      const response = await fetch(
        "https://dashboard.jyotirvani.com/api/addreview",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            astrologerid: id,
            userid: user?.id,
            name: user?.name || user?.customer_name || "User",
            email: user?.email,
            rating: reviewForm.rating,
            review: reviewForm.review,
          }),
        },
      );

      const result = await response.json();

      if (result.status) {
        const now = new Date();

        const newReview = {
          name: user?.name || user?.customer_name || "User",
          rating: reviewForm.rating,
          review: reviewForm.review,
          created_at: now.toISOString(),
        };

        setReviews((prev) => [newReview, ...prev]);

        setReviewForm({
          rating: 0,
          review: "",
        });

        toast.success("Review submitted successfully");
      } else {
        toast.error(result.message || "Review submit failed");
      }
    } catch (error) {
      console.error("Review Submit Error:", error);
      toast.error("Something went wrong");
    } finally {
      setReviewSubmitting(false);
    }
  };

  if (!astro) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        <h3>Loading profile...</h3>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <Toaster position="top-right" />

      {showSuccessPopup && (
        <div className="astro-qr-modal-overlay">
          <div
            className="astro-qr-modal-content"
            style={{ textAlign: "center" }}
          >
            <h2 style={{ color: "green" }}>Payment Successful 🎉</h2>
            <p>{successMessage}</p>

            <button
              className="ra-plan-contact-btn"
              onClick={() => {
                if (whatsappMessage) {
                  window.open(
                    `https://wa.me/919616339090?text=${encodeURIComponent(
                      whatsappMessage,
                    )}`,
                    "_blank",
                  );
                }

                localStorage.removeItem("astro_whatsapp_message");
                setShowSuccessPopup(false);
              }}
            >
              Continue WhatsApp
            </button>
          </div>
        </div>
      )}

      <div className="ra-astrologer-detail">
        <div className="profile-header">
  <div className="profile-image-wrapper">
    <img
      src={astro?.profileImage}
      alt={astro?.name}
      className="profile-photo"
    />

    {/* <div className="online-badge">Online</div> */}
  </div>

  <div className="profile-info">
    <h2>
      {astro?.name}
      <span className="verified">✔</span>
    </h2>

    <div className="astro-tags">
      {astro?.expertise?.map((item, index) => (
        <span key={index}>{item}</span>
      ))}
    </div>

    <p className="astro-language">
      🌐 {astro?.languages?.join(", ")}
    </p>

    <div className="astro-details-row">
      <div className="astro-detail-box">
        <strong>{astro?.experience}</strong>
        <span>Experience</span>
      </div>

      <div className="astro-detail-box">
        <strong>{astro?.startPrice}</strong>
        <span>Starting Price</span>
      </div>

      <div className="astro-detail-box">
        <strong>4.9 ★</strong>
        <span>Rating</span>
      </div>
    </div>

    <div className="profile-actions">
      <button className="btn btn-warning" onClick={handlePayClick}>
        💬 Chat Now
      </button>

      <button
        className="btn btn-warning consultation-btn"
        onClick={handleBookConsultation}
      >
        📞 Book Consultation
      </button>
    </div>
  </div>
</div>

        {showModal && (
          <div className="astro-qr-modal-overlay">
            <div className="astro-qr-modal-content">
              <div className="payment-form">
                <h3>
                  {paymentType === "consultation"
                    ? "Book Consultation"
                    : "Chat Now"}
                </h3>

                <div className="input-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Name *"
                    value={form.name}
                    onChange={handleFormChange}
                  />

                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={form.email}
                    onChange={handleFormChange}
                  />
                </div>

                {errors.name && <p className="error-text">{errors.name}</p>}
                {errors.email && <p className="error-text">{errors.email}</p>}

                <div className="input-group">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone Number *"
                    value={form.phone}
                    onChange={handleFormChange}
                    maxLength={10}
                  />
                </div>

                <div className="input-group">
                  <input
                    type="date"
                    name="dob"
                    value={form.dob}
                    onChange={handleFormChange}
                  />
                </div>

                <div className="input-group">
                  <input
                    type="time"
                    name="birthTime"
                    value={form.birthTime}
                    onChange={handleFormChange}
                  />
                </div>

                <div className="input-group">
                  <input
                    type="text"
                    name="birthPlace"
                    placeholder="Place of Birth (City, State, Country)"
                    value={form.birthPlace}
                    onChange={handleFormChange}
                  />
                </div>

                {errors.phone && <p className="error-text">{errors.phone}</p>}
                {errors.dob && <p className="error-text">{errors.dob}</p>}
                {errors.birthTime && (
                  <p className="error-text">{errors.birthTime}</p>
                )}
                {errors.birthPlace && (
                  <p className="error-text">{errors.birthPlace}</p>
                )}

                <div className="payment-summary">
                  <p>
                    <strong>Astrologer:</strong> {astro?.name}
                  </p>

                  <p>
                    <strong>Service:</strong>{" "}
                    {paymentType === "consultation"
                      ? "Book Consultation"
                      : "Chat Now"}
                  </p>

                  <p>
                    <strong>Amount:</strong> ₹{getPaymentAmount()}
                  </p>
                </div>

                <div className="payment-buttons">
                  <button
                    type="button"
                    className="ra-plan-contact-btn"
                    onClick={handlePayment}
                    disabled={isPaying}
                  >
                    {isPaying ? "Processing..." : `Pay ₹${getPaymentAmount()}`}
                  </button>

                  <button
                    type="button"
                    className="ra-plan-close-btn"
                    onClick={handleClose}
                    disabled={isPaying}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="carousel-section">
          {images.length > 0 ? (
            images.map((src, index) => (
              <img
                key={index}
                src={src}
                alt={`slide-${index}`}
                className="carousel-img"
              />
            ))
          ) : (
            <p>No gallery images available.</p>
          )}
        </div>

        <div className="about-section">
          <h3>About me</h3>
          <p>{astro?.about}</p>
        </div>

        <div className="review-section">
          <div className="review-header">
            <h3>Customer Reviews</h3>
          </div>

          <form className="review-form" onSubmit={handleReviewSubmit}>
            <div className="review-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  onClick={() =>
                    setReviewForm((prev) => ({
                      ...prev,
                      rating: star,
                    }))
                  }
                  style={{
                    cursor: "pointer",
                    fontSize: "28px",
                    color: reviewForm.rating >= star ? "#facc15" : "#d1d5db",
                  }}
                >
                  ★
                </span>
              ))}
            </div>

            <textarea
              placeholder="Write your review..."
              value={reviewForm.review}
              onChange={(e) =>
                setReviewForm((prev) => ({
                  ...prev,
                  review: e.target.value,
                }))
              }
              rows={4}
              className="review-textarea"
            />

            <button
              type="submit"
              className="review-submit-btn"
              disabled={reviewSubmitting}
            >
              {reviewSubmitting ? "Submitting..." : "Submit Review"}
            </button>
          </form>

          {reviewLoading ? (
            <p>Loading reviews...</p>
          ) : reviews.length === 0 ? (
            <p>No reviews yet.</p>
          ) : (
            <div className="review-list">
              {reviews.map((item, index) => {
                const reviewDate = item.created_at
                  ? new Date(item.created_at)
                  : null;

                return (
                  <div className="review-card" key={index}>
                    <div className="review-top">
                      <div>
                        <h4>{item.name || "User"}</h4>

                        <p>
                          {reviewDate && !isNaN(reviewDate)
                            ? reviewDate.toLocaleString()
                            : "Date not available"}
                        </p>
                      </div>

                      <div className="review-rating">
                        {"★".repeat(Number(item.rating || 0))}
                      </div>
                    </div>

                    <p className="review-message">{item.review}</p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConsultantProfile;
